module.exports = __webpack_public_path__ + "img/exam-application.2e789bde.svg";